import React, {
  useEffect, useLayoutEffect, useState, useRef, useContext, useMemo,
} from "react";

import {
  debounce, difference, has, isEmpty, isEqual,
} from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";

// import SubmissionInfoBanner from "./SampleDetailsPage/SubmissionInfoBanner";
import useAbortController from "../../Common/hooks/useAbortController";
import SuccessAnimation from "../../Common/UIComponents/SuccessAnimation";
import CreditPurchaseModal from "../CreditPurchase/CreditPurchaseModal";
import { buildResolveSampleIssueSamplePayload, getIssueSampleTests } from "../MainPage/Submissions/submissionIssueUtils";
import SampleFunctionContext from "../SampleFunctionContext";
import SampleSubmissionContext from "../SampleSubmissionContext";
import SampleSubmissionConfirmModal from "../SampleSubmissionModal/SampleSubmissionConfirmModal";
import ScheduleShipmentModal from "../SampleSubmissionModal/ScheduleShipmentModal";
import SubmissionReceiptModal from "../SampleSubmissionModal/SubmissionReceiptModal/SubmissionReceiptModal";
import { CHAR_LIMITS } from "./Constant";
import SampleDetailsPage from "./SampleDetailsPage/SampleDetailsPage";
import SubmissionDetailsAddressPage from "./SubmissionDetailsAddressPage/SubmissionDetailsAddressPage";

import { getCustomerConfig, getUserCredentials } from "../../../utils/common";
import {
  deleteFileFromS3WithPresigned, getFileNameAndExtensionFromPath, uploadFileToS3WithPresigned, getFilePath,
} from "../../../utils/helpers";
import {
  canAddSampleSubmissionTest,
  hasPermission,
  // hasSampleSubmissionTestDirectoryFeature,
  permissions,
} from "../../../utils/Permissions";
import { isPrepaidOrSubscriptionCustomer } from "../../MyAccount/UsageMetrics/utils";
import {
  buildPickupScheduleWizardState,
  SUPPLY_PICKUP_PATH,
} from "../../SupplyPickup/Common/utils";
import {
  buildCreditPurchaseRowsFromClassify,
  getAvailableCreditsByCode,
  getClassifyCreditCheckError,
} from "../CreditPurchase/utils";
import { SAMPLE_SUBMISSION_BASE } from "../utils";
import { removeReplicateTag } from "./helpers";

import "./SubmissionForm.css";

import {
  addSampleToDraft,
  editSampleInDraft,
  deleteSampleFromDraft,
  saveDraft,
  addSamplesToSubmission,
  editSampleInSubmission,
  submitForm,
  getSampleID,
  getTestList,
  resolveSampleIssues,
  getCustomerAddress,
} from "../../../actions/sampleSubmission";
import { classifyUsageTests, fetchUsageCredits } from "../../../actions/usage";

const EDIT_CREDIT_PURCHASE_INITIAL_STATE = {
  open: false,
  classifyResponse: null,
  availableCreditsByCode: null,
  customerType: null,
};
// import { getTestDirectory, TEST_SUGGESTION_CATEGORY } from "../../../actions/testDirectory";

export default function SubmissionForm(props) {
  const {
    setShowSubmissionForm,
    setSampleFieldLoaded,
    draftEditing,
    setDraftEditing,
    submissionEditingSample,
    setSubmissionEditingSample,
    submissionAddingSamples,
    setSubmissionAddingSamples,
    sampleFields,
    sampleFieldsInfo,
    delimiterRegex,
    sampleIdFields,
    setAddressPage,
    setSubmissionNameNav,
    setSubmissionModeNav,
    setShowExitModal,
    embeddedIssueModal = false,
    onCloseEmbedded,
    onIssueFlowSuccess,
    setHideBreadcrumbBack,
  } = props;
  const history = useHistory();
  const { isLoggedOut, sampleCategory, thirdParty } = useContext(SampleSubmissionContext);
  const {
    closeRef, setOnAddBackButton, backRef, addressPageBreadcrumbBackRef,
  } = useContext(SampleFunctionContext);

  const [showAddressPage, setShowAddressPage] = useState(!submissionEditingSample && !submissionAddingSamples); // don't show address page when editing/adding samples in a submission
  /** 0: don't show any modals, 1: show unsaved changes submission modal, 2: show regular submission modal, 3: show delete sample modal */
  const [showConfirmationModal, setShowConfirmationModal] = useState(0);
  const [editingSubmittedSampleComposite, setEditingSubmittedSampleComposite] = useState(true);
  const [testInfoMap, setTestInfoMap] = useState(new Map());
  /* After user adds a new sample, saves an edited sample, cancels editing, switches the editing sample to another,
  * "clearTestSearch" will be set from false to true. We will reset the search input to empty and get all test suggestions. */
  const [clearTestSearch, setClearTestSearch] = useState(false);
  const [testsSelected, setTestsSelected] = useState({});
  const [inputValuesSavedForNext, setInputValuesSavedForNext] = useState({});
  const [saveTestsForNext, setSaveTestsForNext] = useState(false);
  const inputValuesRefs = useRef({});
  const imageInfoRef = useRef({ originalUrl: "", editedUrl: "", file: null });
  const [clearSampleDetailsForm, setClearSampleDetailsForm] = useState(false);
  const [loadSampleEditing, setLoadSampleEditing] = useState(false);
  const [compositeSample, setCompositeSample] = useState(null);
  const [loadSampleDeleting, setLoadSampleDeleting] = useState(false);
  const [loadDraftState, setLoadDraftState] = useState(false);
  const [loadSavedState, setLoadSavedState] = useState(false);
  const [isLoadingSampleId, setIsLoadingSampleId] = useState(false);
  const [submissionDetails, setSubmissionDetails] = useState({
    submissionName: "", submissionID: "", poNumber: "",
  });
  const [customerDetails, setCustomerDetails] = useState({ customerID: "", submittedBy: "", userEmail: "" });
  const [sampleList, setSampleList] = useState([]);
  const [savedState, setSavedState] = useState(null);
  // const [sampleFieldsState, setSampleFieldsState] = useState(null);
  const [sampleEditing, setSampleEditing] = useState({});
  const [sampleEditingIdx, setSampleEditingIdx] = useState(-1);
  const [sampleToDeleteIdx, setSampleToDeleteIdx] = useState(-1);
  const [waitingForAddEditAPI, setWaitingForAddEditAPI] = useState(false); // loading state for add/edit sample
  const [loadingImage, setLoadingImage] = useState(false);
  const [submitLoadingState, setSubmitLoadingState] = useState(false);
  const [, setDraftLastSavedTime] = useState("");
  const [invalidInputFound, setInvalidInputFound] = useState(false);
  const [invalidMandatoryFound, setInvalidMandatoryFound] = useState(false);
  const [invalidTest, setInvalidTest] = useState(false);
  const [generatedSampleID, setGeneratedSampleID] = useState("");
  const [sampleIDGenerationError, setSampleIDGenerationError] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showScheduleShipmentModal, setShowScheduleShipmentModal] = useState(false);
  const [customerLogistics, setCustomerLogistics] = useState(null);
  const [scheduleShipmentLoading, setScheduleShipmentLoading] = useState(false);
  const [pesticideSample, setPesticideSample] = useState("");
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [editCreditCheckLoading, setEditCreditCheckLoading] = useState(false);
  const editConfirmOpenRef = useRef(true);
  const [editCreditPurchase, setEditCreditPurchase] = useState(EDIT_CREDIT_PURCHASE_INITIAL_STATE);
  const editCreditCheckAbortRef = useRef(null);
  const submissionForReceiptModal = useRef();
  const sampleFromSubmission = useRef();
  const submissionEditingSamplePayload = useRef();
  const sampleListScrollbar = useRef();
  const commentRef = useRef();
  const { setNewAbortController, clearAbortController } = useAbortController(); // for displaysampleid api

  /** componentDidMount - get list of all tests, convert to map */
  useEffect(() => {
    const apiGetTestList = async () => {
      const customerID = (isLoggedOut && !thirdParty) ? customerDetails.customerID : undefined;
      const { success, testList } = await getTestList("", customerID, sampleCategory);
      if (success) {
        // Browse Tests fallback (pending confirmation — keep commented until flow is approved):
        // Same as AnalysisRequest — empty mapping + no Test Directory → test-directory list.
        // let resolvedTests = Array.isArray(testList) ? testList : [];
        // if (
        //   resolvedTests.length === 0
        //   && !hasSampleSubmissionTestDirectoryFeature()
        // ) {
        //   const directoryResult = await getTestDirectory(
        //     "",
        //     sampleCategory,
        //     customerID,
        //     undefined,
        //     TEST_SUGGESTION_CATEGORY.TEST_DIRECTORY,
        //   );
        //   if (directoryResult.success) {
        //     resolvedTests = Array.isArray(directoryResult.tests) ? directoryResult.tests : [];
        //   }
        // }
        const test_map = new Map();
        (testList || []).forEach((testObj) => {
          // Use resolvedTests.forEach when enabling the fallback above.
          if (testObj?.name) test_map.set(testObj.name, testObj);
        });
        setTestInfoMap(test_map);
      }
    };
    if ((!isLoggedOut || thirdParty) || customerDetails.customerID) {
      apiGetTestList();
    }
  }, [customerDetails]); // eslint-disable-line

  /** when user is editing a draft, set submission details, sample list */
  useEffect(() => {
    if (draftEditing) {
      setLoadDraftState(true);
      const {
        submission_name, po, submission_id,
        submission_date, samples, test_list,
      } = draftEditing;
      setSubmissionDetails({
        submissionName: submission_name, poNumber: po, submissionID: submission_id,
      });
      setSubmissionNameNav(submission_name);
      setDraftLastSavedTime(submission_date);
      setSampleList(generateUUIDs(Array.isArray(samples) ? samples : [])); // eslint-disable-line
      const disableTestListMod = !canAddSampleSubmissionTest();
      const resumeSaveTests = draftEditing._resume_save_tests_for_next;
      if (typeof resumeSaveTests === "boolean") {
        setSaveTestsForNext(!disableTestListMod && resumeSaveTests);
      } else {
        setSaveTestsForNext(!disableTestListMod && (Boolean(test_list?.length) ?? false));
      }
    }
  }, [draftEditing]); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Restore in-progress tests after Request New Test.
   * Runs when testInfoMap is ready; SampleDetails skips draft test_list when _resume_tests is set.
   */
  useEffect(() => {
    const resumeTests = draftEditing?._resume_tests;
    if (!Array.isArray(resumeTests) || !resumeTests.length || !testInfoMap?.size) return;
    const next = {};
    resumeTests.forEach((name) => {
      if (!name) return;
      next[name] = { ...(testInfoMap.get(name) ?? {}) };
    });
    setTestsSelected(next);
  }, [draftEditing, testInfoMap]);

  /** when user is editing a sample in a submission, set submission details, sample list */
  useEffect(() => {
    if (submissionEditingSample) {
      const {
        submit_name,
        submit_id,
        sample,
        po,
      } = submissionEditingSample;
      setSubmissionNameNav(submit_name);
      setSubmissionDetails({
        submissionName: submit_name, poNumber: po, submissionID: submit_id,
      });
      const formattedSample = { sample_id: sample.sample_id };
      formattedSample.test_list = getIssueSampleTests(sample);
      const cancelRevertState = {
        fields: {},
        savedForNext: { ...inputValuesSavedForNext },
        tests: {},
        saveTests: false,
      };
      sampleFields.forEach((field) => {
        formattedSample[field] = sample[field] ?? "";
        cancelRevertState.fields[field] = {
          value: formattedSample[field] != null ? String(formattedSample[field]) : "",
          autofilled: false,
        };
      });
      formattedSample.sample_type = sample.sample_type ?? formattedSample.sample_type ?? "";
      formattedSample.test_list.forEach((testName) => {
        cancelRevertState.tests[testName] = {
          ...(testInfoMap.get(testName) ?? {}),
        };
      });
      (sample.tests_list ?? []).forEach((testObj) => {
        const name = typeof testObj === "string" ? testObj : testObj?.Test;
        if (!name) return;
        cancelRevertState.tests[name] = {
          ...(testInfoMap.get(name) ?? {}),
          ...(typeof testObj === "object" ? testObj : {}),
        };
      });
      if (sampleCategory === "environment") {
        formattedSample.image_path = sample.image_path;
        cancelRevertState.imageInfoRef = {
          originalUrl: sample.image_src ?? "",
          editedUrl: sample.image_src ?? "",
          file: null,
          imageWasEdited: false,
        };
      }
      sampleFromSubmission.current = formattedSample;
      setSampleList(generateUUIDs([formattedSample])); // eslint-disable-line
      setSavedState(cancelRevertState);
      setLoadSampleEditing(true);
      // if (submissionEditingSample.issueFlow) {
      //   setSampleEditingIdx(-1);
      //   setSampleEditing({});
      // } else {
      setSampleEditingIdx(0);
      setSampleEditing(formattedSample);
    // }
    }
  }, [submissionEditingSample]); // eslint-disable-line

  /** Fill sample field values once sampleFields finish loading (issue edit can open first). */
  useEffect(() => {
    if (!submissionEditingSample?.issueFlow || !sampleFields?.length) return;
    const sourceSample = submissionEditingSample.sample || {};
    const sourceTests = getIssueSampleTests(sourceSample);
    setSampleList((prev) => {
      if (!prev.length) return prev;
      const current = prev[0];
      const needsFieldFill = sampleFields.some((field) => current[field] === undefined);
      const needsTestFill = sourceTests.length > 0 && !(current.test_list?.length);
      if (!needsFieldFill && !needsTestFill) return prev;
      const updated = { ...current };
      if (needsFieldFill) {
        sampleFields.forEach((field) => {
          updated[field] = sourceSample[field] ?? updated[field] ?? "";
        });
        if (sourceSample.sample_type) {
          updated.sample_type = sourceSample.sample_type;
        }
      }
      if (needsTestFill) {
        updated.test_list = sourceTests;
      }
      return [updated, ...prev.slice(1)];
    });
    setSavedState((prev) => {
      if (!prev?.fields) return prev;
      const nextFields = { ...prev.fields };
      sampleFields.forEach((field) => {
        if (nextFields[field]) return;
        const value = sourceSample[field] ?? "";
        nextFields[field] = {
          value: value != null ? String(value) : "",
          autofilled: false,
        };
      });
      return { ...prev, fields: nextFields };
    });
  }, [sampleFields, submissionEditingSample]);

  /**
   * Update the back button or the back button.
   */
  useEffect(() => {
    if (sampleEditingIdx > -1) {
      setShowExitModal(true);
    } else {
      setShowExitModal(false);
    }
  }, [sampleEditingIdx]); // eslint-disable-line

  /** when user is adding samples to a submission, set submission details */
  useEffect(() => {
    if (submissionAddingSamples) {
      const {
        submit_name,
        submit_id,
        po,
        comment,
      } = submissionAddingSamples;
      setSubmissionNameNav(submit_name);
      setSubmissionDetails({
        submissionName: submit_name, poNumber: po, submissionID: submit_id, comment,
      });
    }
  }, [submissionAddingSamples]); // eslint-disable-line

  useEffect(() => {
    if (typeof setSubmissionModeNav !== "function") return;
    if (draftEditing || submissionEditingSample || submissionAddingSamples) {
      setSubmissionModeNav("edit");
    } else {
      setSubmissionModeNav("add");
    }
  }, [draftEditing, submissionEditingSample, submissionAddingSamples, setSubmissionModeNav]);

  /** when loadSavedState is true, and form is mounted, overwrite state with savedState */
  useEffect(() => {
    if (loadSavedState && !showAddressPage && savedState !== null) {
      const {
        savedForNext, tests, saveTests, fields,
      } = savedState;
      setInputValuesSavedForNext(savedForNext);
      setTestsSelected(tests);
      setSaveTestsForNext(saveTests);
      const hasMRL = Object.values(tests).some((t) => t?.test_category === "MRL");
      if (sampleCategory !== "environment" && hasMRL) {
        setPesticideSample(String(fields?.sample_type?.value ?? ""));
      } else if (!hasMRL) {
        setPesticideSample("");
      }
    }
  }, [loadSavedState, showAddressPage, savedState, sampleCategory]);

  /** Manage the nav for the submission form on address or details page */
  useLayoutEffect(() => {
    setAddressPage(showAddressPage);
  }, [showAddressPage, setAddressPage]);

  /** Hide breadcrumb back in missing/damaged issue edit overview */
  useLayoutEffect(() => {
    if (typeof setHideBreadcrumbBack !== "function") return undefined;
    setHideBreadcrumbBack(Boolean(submissionEditingSample?.issueFlow && !showAddressPage));
    return () => setHideBreadcrumbBack(false);
    // eslint-disable-next-line
  }, [submissionEditingSample?.issueFlow, showAddressPage, setHideBreadcrumbBack]);

  /** Manage the animation for the time */
  useEffect(() => {
    if (showSuccessAnimation) {
      setTimeout(() => {
        setShowSuccessAnimation(false);
        setShowReceiptModal(true);
      }, 1000);
    }
  }, [showSuccessAnimation]); // eslint-disable-line

  /**
   * Set the field's ref
   * @param  {String} field json_field
   * @param  {input DOM element} ref ref for the field's input
   */
  const setInputValuesRefs = (field, ref) => {
    if (inputValuesRefs.current[field] === undefined) {
      inputValuesRefs.current[field] = {};
    }
    inputValuesRefs.current[field].ref = ref;
  };

  /**
   * Set image related info
   * @param  {Object} info { originalUrl, editedUrl, file, crop, rotate }
   */
  const setImageInfoRef = (info) => {
    imageInfoRef.current = { ...info };
  };

  /**
   * Set whether the field's value was autofilled or not
   * @param  {String} field json_field
   * @param  {String} fieldVal value of json_field
   * @param  {Boolean} autofilled if the input was autofilled or not
   * @param  {Boolean} emptyStringAutofilledValue whether empty strings are set to autofilled true or false. empty strings are default set to true so these fields can be autofilled regardless of autofilled value.
   */
  const setInputValueAutofilled = (field, fieldVal, autofilled, emptyStringAutofilledValue = true) => {
    if (inputValuesRefs.current[field] === undefined) {
      inputValuesRefs.current[field] = {};
    }
    inputValuesRefs.current[field].autofilled = fieldVal === "" ? emptyStringAutofilledValue : autofilled;
  };

  /**
   * When the user checks/unchecks save for next, update the saved for next state
   * @param  {String} field json_field
   * @param  {Boolean} overrideValue set value to overrideValue directly
   */
  const toggleSaveForNext = (field, overrideValue = null) => {
    if (overrideValue !== null) {
      inputValuesSavedForNext[field] = overrideValue; // set to the overrideValue
    } else { inputValuesSavedForNext[field] = !inputValuesSavedForNext[field]; }
    setInputValuesSavedForNext({ ...inputValuesSavedForNext });
  };

  /**
   * When the user checks/unchecks save for next, update the saved for next state
   * @param  {String} field json_field
   * @param  {Boolean} overrideValue set value to overrideValue directly
   */
  const clearCompositeSaveForNext = (fields) => {
    if (fields.length) {
      fields.forEach((field) => {
        inputValuesSavedForNext[field] = false;
      });
      setInputValuesSavedForNext({ ...inputValuesSavedForNext });
    }
  };

  //  /**
  //  * Update the specified sample
  //  * @param  {Number} idx index of sample in sampleList
  //  * @param  {Object} updatedSample updated sample object
  //  */
  //  const updateSample = (idx, updatedSample) => {
  //   sampleList[idx] = updatedSample;
  //   setSampleList([...sampleList]);
  // };

  /**
   * When loading a draft, generate new uuids for each sample for animation purposes
   * @param  {Array} draftSampleList array of samples
   * @return  {Array} array of samples with uuids
   */
  const generateUUIDs = (draftSampleList) => (Array.isArray(draftSampleList) ? draftSampleList : []).map((sample) => (
    {
      ...sample,
      uuid: uuid(),
    }));

  /**
   * Call the api to generate the sample id
   * @param {Object} inputValues {json_field: value, ...}
   */
  const generateSampleID = async (inputValues, editingSampleID, sample_list) => {
    setIsLoadingSampleId(true);
    if (!isLoggedOut || thirdParty) {
      const { submissionID } = submissionDetails;
      const sample = { po: submissionDetails.poNumber };
      if (submissionAddingSamples) {
        sample.po = submissionAddingSamples.po;
      } else if (submissionEditingSample) {
        sample.po = submissionEditingSample.po;
      }

      for (let i = 0; i < sampleFields.length; i++) {
        const json_field = sampleFields[i];
        if (inputValues !== undefined) {
          sample[json_field] = removeReplicateTag(inputValues[json_field].trim() ?? "");
        } else {
          const ref = inputValuesRefs.current[json_field]?.ref;
          if (ref !== undefined && ref !== null) {
            const val = ref.value.trim();
            sample[json_field] = val;
          } else {
            sample[json_field] = "";
          }
        }
      }

      const payload = { submission_id: submissionID, sample };
      if (sampleCategory !== "") {
        payload.sample_category = sampleCategory;
      } else if (submissionEditingSample) {
        payload.sample_category = submissionEditingSample.sample_category;
      }
      if (editingSampleID !== undefined) {
        payload.editing_sample_id = editingSampleID;
      }
      if (submissionAddingSamples) {
        if (sample_list) {
          payload.sample_id_list = sample_list.map(({ sample_id }) => sample_id);
        } else {
          payload.sample_id_list = sampleList.map(({ sample_id }) => sample_id);
        }
      }
      const newAbortController = setNewAbortController();
      const { success, sample_id } = await getSampleID(payload, newAbortController.signal).finally(() => setIsLoadingSampleId(false));

      if (newAbortController.signal.aborted) {
        return { canceled: true };
      }

      clearAbortController();

      if (success) {
        setGeneratedSampleID(sample_id);
        setSampleIDGenerationError(false);
        return { success: true, sample_id };
      }
      setGeneratedSampleID("");
      setSampleIDGenerationError(true);
      return { success: false };
    }
    return { success: false };
  };

  /**
   * Debounce generateSampleID, will wait until 500ms have elapsed to call again.
   * useMemo keeps the debounced function instance the same between rerenders (more performant than useCallback),
   * the function will only reinitialize when a dependency array value updates (needed if function uses state/prop that changes i.e. sampleList)
   * @return {Function} debounced generateSampleID
   */
  const debouncedGenerateSampleID = useMemo(() => debounce((inputVals, sampleEditingID) => {
    generateSampleID(inputVals, sampleEditingID);
  }, 500), [sampleList, submissionDetails, sampleFields]); // eslint-disable-line
  /**
   * Cleanup the debounce function on unmount
   */
  useEffect(() => () => {
    debouncedGenerateSampleID.cancel();
    if (editCreditCheckAbortRef.current) {
      editCreditCheckAbortRef.current.abort();
    }
  }, []); // eslint-disable-line

  /**
   * Upload the image to the target s3 bucket
   * @param {*} file the current image uploaded from local
   * @returns the aws api response and the file path
   */
  const addImageToAWS = async (file) => {
    if (file) {
      // console.log("file size", `${sizeInMB.toFixed(2)}MB`);
      // const url = window.URL.createObjectURL(new Blob([file], { type: file.type }));
      // if (url) {
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = file.name;
      //   a.click();
      // }
      const { name, ext } = getFileNameAndExtensionFromPath(file.name);

      const fileInfo = {
        file, folderPath: "SampleSubmission/", fileName: `${name}_${Date.now()}${ext}`, type: file.type,
      };
      const path = getFilePath(fileInfo);
      const fileBlobObj = await uploadFileToS3WithPresigned([fileInfo], "private");
      if (fileBlobObj && fileBlobObj[path]) {
        return { success: true, path: fileBlobObj[path].path };
      }
    } return { success: false };
  };

  /**
   * Api POST call to add sample. Gets submission_id on first add.
   * @param {Object} sample the sample being added
   * @param {Object} savedFields {json_field : value} for fields that are saved for next
   * @return  {Boolean} true if successfully added, false otherwise (show toast message)
   * @return  {String} return the generated sampleID
   */
  const apiAddSampleDraft = async (sample, savedFields) => {
    const {
      submissionName, poNumber, submissionID,
    } = submissionDetails;
    const payload = {
      submissionName,
      poNumber,
      submissionID,
      sample,
      savedFields,
      testList: saveTestsForNext ? Array.from(Object.keys(testsSelected)) : [],
      sample_category: sampleCategory,
      type: "non_scheduled",
      schedule_date: "",
    };
    const {
      success, message, submissionID: submission_id, sampleID,
    } = await addSampleToDraft(payload);
    if (success) {
      setSubmissionDetails({ ...submissionDetails, submissionID: submission_id });
    } else {
      toast.error(message);
    }
    return { success, sampleID };
  };

  /**
   * Api PATCH call to edit sample. Gets new sample_id for sample.
   * @param oldSampleID the old sample id of the edited sample
   * @param editedSample the edited sample
   * @param {Object} savedFields {json_field : value} for fields that are saved for next
   * @return  {Boolean} true if successfully edited, false otherwise (show toast message)
   * @return  {String} return the generated sampleID
   */
  const apiEditSampleDraft = async (oldSampleID, editedSample, savedFields) => {
    const {
      submissionName, poNumber, submissionID,
    } = submissionDetails;
    const payload = {
      submissionName,
      poNumber,
      submissionID,
      oldSampleID,
      editedSample,
      savedFields,
      testList: saveTestsForNext ? Array.from(Object.keys(testsSelected)) : [],
      sampleCategory,
    };
    const {
      success, message, sampleID,
    } = await editSampleInDraft(payload);
    if (!success) {
      toast.error(message);
    }
    return { success, sampleID };
  };

  /**
   * Api DELETE call to delete sample
   * @param sampleID the sample id of the sample to be deleted
   * @param sampleType the sample type of the sample to be deleted
   * @return  {Boolean} true if successfully deleted, false otherwise (show toast message)
   */
  const apiDeleteSampleDraft = async (sampleID, sampleType) => {
    const {
      submissionName, poNumber, submissionID,
    } = submissionDetails;
    const payload = {
      submissionName,
      poNumber,
      submissionID,
      sampleID,
      sampleType,
      sampleCategory,
    };
    const {
      success, message,
    } = await deleteSampleFromDraft(payload);
    if (!success) {
      toast.error(message);
    }
    return success;
  };

  /**
   * Api POST call to submit form.
   * @return  {Boolean} true if successfully submitted, false otherwise (show toast message)
   */
  const apiSubmitForm = async () => {
    const {
      submissionName, poNumber, submissionID,
    } = submissionDetails;
    const payload = {
      submissionName,
      poNumber,
      submissionID,
      sampleList,
      comment: commentRef.current.resizableTextArea.textArea.value.trim() ?? "",
      sampleCategory,
    };
    const { success, message } = await submitForm(payload, (isLoggedOut && !thirdParty) ? customerDetails : undefined);
    if (success) {
      toast.success("Successfully submitted form");
    } else {
      toast.error(message);
    }
    return success;
  };

  /**
   * Api POST call to add samples to a submission.
   * @param {Object} sample the samples being added
   * @return  {Boolean} true if successfully added, false otherwise (show toast message)
   */
  const apiSubmitAddedSamples = async () => {
    const { submissionID, poNumber } = submissionDetails;
    const { status } = submissionAddingSamples;
    const payload = {
      submissionID,
      sampleList,
      status,
      poNumber,
      sampleCategory,
    };
    const { success, message } = await addSamplesToSubmission(payload);
    if (success) {
      toast.success(`Successfully added sample${sampleList.length > 1 ? "s" : ""}`);
    } else {
      toast.error(message);
    }
    return success;
  };

  /**
   * Api PATCH call to edit a sample in a submission.
   * @param {Object} oldSample the original sample
   * @param {Object} newSample the edited sample
   * @return  {Boolean} true if successfully edited, false otherwise
   */
  const apiSubmitEditedSample = async () => {
    const payload = { ...submissionEditingSamplePayload.current };
    payload.sample_category = sampleCategory;
    delete payload.oldSample; // remove oldSample key, this was needed only for the edits modal
    payload.sample = payload.newSample;
    delete payload.newSample; // remove newSample key (replaced by sample key)
    // paload.comment = commentRef.current.resizableTextArea.textArea.value.trim();
    if (payload) {
      const newSample = sampleList[0];
      const { image_file } = newSample;
      const { image_path: old_image_path } = sampleFromSubmission.current;
      let deleteImagePath;
      /** Upload image to aws and delete old image if it exists */
      if (has(payload, "new_image_src")) {
        if (payload.new_image_src && image_file) { // a new image or crop was created
          if (old_image_path) {
            deleteImagePath = old_image_path;
          }
          const { success, path } = await addImageToAWS(image_file);
          if (!success) {
            toast.error("Image failed to upload");
            return false;
          }
          payload.image_path = path ?? "";
          payload.sample.image_path = path ?? "";
        } else if (!payload.new_image_src) { // the image was removed from the sample
          if (old_image_path) {
            deleteImagePath = old_image_path;
          }
          payload.image_path = "";
          payload.sample.image_path = "";
        }
        delete payload.image_src;
        delete payload.new_image_src;
      }
      /** If image upload successful, call edit submission api */
      const { success, message } = await editSampleInSubmission(payload);
      if (success) {
        toast.success("Successfully edited sample");
        if (deleteImagePath) {
          deleteFileFromS3WithPresigned([deleteImagePath], "private");
        }
      } else {
        toast.error(message);
      }
      return success;
    }
    toast.error("Unable to submit edited sample");
    return false;
  };

  /**
   * Resets state back to default (used when logged out, after submitting)
   */
  const resetSubmissionFormState = () => {
    /** Submission state */
    setCustomerDetails({ customerID: "", submittedBy: "", userEmail: "" });
    setSubmissionDetails({
      submissionName: "", submissionID: "", poNumber: "",
    });
    setDraftLastSavedTime("");
    submissionForReceiptModal.current = null;
    /** Sample Details Inputs state */
    inputValuesRefs.current = {};
    setInputValuesSavedForNext({});
    setImageInfoRef({ originalUrl: "", editedUrl: "", file: "" });
    setClearSampleDetailsForm(false);
    setLoadSavedState(false);
    setSavedState(null);
    setInvalidInputFound(false);
    setInvalidMandatoryFound(false);
    setGeneratedSampleID("");
    /** Samples state */
    setLoadSampleEditing(false);
    setSampleEditing({});
    setSampleEditingIdx(-1);
    setSampleToDeleteIdx(-1);
    setSampleList([]);
    /** Tests state */
    setTestsSelected({});
    setSaveTestsForNext(false);

    /** Show address page */
    setShowAddressPage(true);
  };

  /**
   * Saves fields, save-for-next values, tests, and tests save-for-next state
   * @param {Object} savedForNext current inputsSavedForNext value
   * @param {Set} tests current selectedTests value
   * @param {Boolean} saveTests current saveTestsForNext value
   */
  const saveCurrentState = (savedForNext, tests, saveTests) => {
    const currState = {
      fields: {}, savedForNext: { ...savedForNext }, tests: { ...tests }, saveTests,
    };
    if (sampleCategory === "environment") {
      currState.imageInfoRef = { ...imageInfoRef.current };
      if (imageInfoRef.current.crop) {
        currState.imageInfoRef.crop = { ...imageInfoRef.current.crop };
      }
    }
    for (let i = 0; i < sampleFields.length; i++) {
      const json_field = sampleFields[i];
      const ref = inputValuesRefs.current[json_field]?.ref;
      const autofilled = inputValuesRefs.current[json_field]?.autofilled;
      if (ref !== undefined && ref !== null) {
        const val = ref.value.trim();
        currState.fields[json_field] = { value: val, autofilled };
      }
    }
    setSavedState(currState);
  };

  /**
   * When user selects clicks back icon from the form page, save current state and show address page.
   */
  const handleGoBackToAddressPage = () => {
    if (sampleEditingIdx === -1) {
      saveCurrentState(inputValuesSavedForNext, testsSelected, saveTestsForNext);
      setLoadSavedState(true);
    }
    setDraftEditing(null);
    setShowConfirmationModal(0);
    setShowAddressPage(true); // go to address form page
  };

  /**
   * When user clicks back icon from the address page, save draft and go back to the main page.
   */
  const handleGoBackToMainPage = async () => {
    history.push(SAMPLE_SUBMISSION_BASE);
    if (isLoggedOut) {
      setShowSubmissionForm(false); // go back to main page
      setSampleFieldLoaded(false);
      setDraftEditing(null);
      setSubmissionEditingSample(null);
      setSubmissionAddingSamples(null);
    }
    setOnAddBackButton(false);
  };

  /**
   * Persist current Sample Submission as a draft before redirecting to Request New Test.
   * Matches existing saveDraft (header/comment only); sample rows stay on BE if already added.
   * @return {Object} { success, submissionID, sampleCategory }
   */
  const handleSaveDraftForRequestNew = async () => {
    const { submissionName, poNumber, submissionID } = submissionDetails;
    const comment = commentRef?.current?.resizableTextArea?.textArea?.value?.trim?.() ?? "";
    const {
      success,
      message,
      submissionID: updatedSubmissionID,
    } = await saveDraft({
      submissionName,
      poNumber,
      submissionID,
      sample_category: sampleCategory,
      type: "non_scheduled",
      schedule_date: "",
      comment,
    });

    if (!success) {
      toast.error(message || "Unable to save draft.");
      return { success: false };
    }

    const nextSubmissionID = updatedSubmissionID || submissionID || "";
    if (!nextSubmissionID) {
      toast.error(message || "Unable to save draft.");
      return { success: false };
    }
    if (nextSubmissionID !== submissionID) {
      setSubmissionDetails((prev) => ({ ...prev, submissionID: nextSubmissionID }));
    }

    return {
      success: true,
      submissionID: nextSubmissionID,
      sampleCategory,
    };
  };

  /**
   * When user selects Submit on the modal, call submit api, show success message if successful
   * and go back to the main page. If it failed, show error message and stay on the page.
   */
  const handleConfirmSubmit = async () => {
    setSubmitLoadingState(true);
    let success;
    if (submissionEditingSample) {
      success = await apiSubmitEditedSample();
    } else if (submissionAddingSamples) {
      success = await apiSubmitAddedSamples();
    } else {
      success = await apiSubmitForm();
    }
    const comment = commentRef?.current?.resizableTextArea.textArea.value.trim() ?? "";
    setSubmitLoadingState(false);
    if (success) {
      setShowConfirmationModal(0);
      if (isLoggedOut && !thirdParty) {
        submissionForReceiptModal.current = {
          samples_list: sampleList.map((sample) => ({ ...sample, tests_list: sample.test_list })),
          num_samples: sampleList.length,
          submit_date: moment(Date.now()).format(),
          submit_name: submissionDetails.submissionName,
          po: submissionDetails.poNumber,
          comment,
        };
      }
      setShowSuccessAnimation(true);
      // setShowReceiptModal(true);
    }
  };

  const handleConfirmSubmitWithSchedule = async (selectedScheduleDateKey) => {
    if (isLoggedOut && !thirdParty) {
      await handleConfirmSubmit();
      return;
    }

    const selectedDate = moment(selectedScheduleDateKey, "YYYY-M-D", true);

    if (!selectedDate.isValid()) {
      await handleConfirmSubmit();
      return;
    }

    const isFutureDate = selectedDate.isAfter(moment(), "day");

    if (isFutureDate) {
      setSubmitLoadingState(true);
      const scheduleDate = selectedDate.format("YYYY-MM-DD");
      const comment = commentRef?.current?.resizableTextArea.textArea.value.trim() ?? "";
      const { submissionName, poNumber, submissionID } = submissionDetails;
      const {
        success: saveDraftSuccess,
        message: saveDraftMessage,
        submissionID: updatedSubmissionID,
      } = await saveDraft({
        submissionName,
        poNumber,
        submissionID,
        sample_category: sampleCategory,
        type: "scheduled",
        schedule_date: scheduleDate,
        comment,
      });
      setSubmitLoadingState(false);

      if (!saveDraftSuccess) {
        toast.error(saveDraftMessage);
        return;
      }

      if (updatedSubmissionID && updatedSubmissionID !== submissionID) {
        setSubmissionDetails((prev) => ({ ...prev, submissionID: updatedSubmissionID }));
      }

      toast.success("Submission schedule saved");
      setShowConfirmationModal(0);
      handleGoBackToMainPage();
      return;
    }

    await handleConfirmSubmit();
  };

  /**
   * For prepaid/subscription customers, check that the tests added while editing a sample
   * are covered by remaining credits. Opens the credit purchase modal when they aren't.
   * @return {Promise<Boolean>} true when the edited sample can be submitted right away
   */
  const checkEditedSampleCredits = async () => {
    const addedTests = (submissionEditingSamplePayload.current?.added_tests ?? [])
      .map((test) => (typeof test === "string" ? test : test?.Test))
      .filter(Boolean);
    if (!submissionEditingSample || !addedTests.length) {
      return true;
    }

    if (!isPrepaidOrSubscriptionCustomer(getCustomerConfig()?.customer_type)) {
      return true;
    }

    if (editCreditCheckAbortRef.current) {
      editCreditCheckAbortRef.current.abort();
    }
    const controller = new AbortController();
    editCreditCheckAbortRef.current = controller;

    setEditCreditCheckLoading(true);
    const creditsResponse = await fetchUsageCredits({ allLocation: true, signal: controller.signal });
    if (controller.signal.aborted || creditsResponse.canceled) {
      if (editCreditCheckAbortRef.current === controller) {
        setEditCreditCheckLoading(false);
      }
      return false;
    }
    if (!creditsResponse.success) {
      setEditCreditCheckLoading(false);
      toast.error(creditsResponse.message || "Unable to load remaining credits.");
      return false;
    }
    if (!isPrepaidOrSubscriptionCustomer(creditsResponse.customer_type)) {
      setEditCreditCheckLoading(false);
      return true;
    }

    const samples = [{
      sample_id: sampleList[0]?.sample_id || "",
      side: sampleList[0]?.sample_category || sampleCategory || "",
      tests: addedTests,
    }];
    const classifyResponse = await classifyUsageTests({ samples, signal: controller.signal });
    if (controller.signal.aborted || classifyResponse.canceled) {
      if (editCreditCheckAbortRef.current === controller) {
        setEditCreditCheckLoading(false);
      }
      return false;
    }
    setEditCreditCheckLoading(false);

    if (!classifyResponse.success) {
      toast.error(classifyResponse.message || "Unable to classify tests.");
      return false;
    }
    const classifyError = getClassifyCreditCheckError(classifyResponse, samples);
    if (classifyError) {
      toast.error(classifyError);
      return false;
    }

    const availableCreditsByCode = getAvailableCreditsByCode(creditsResponse);
    const creditsRequiredRows = buildCreditPurchaseRowsFromClassify(classifyResponse, {
      availableCreditsByCode,
    });
    if (!creditsRequiredRows) {
      return true;
    }

    setShowConfirmationModal(0);
    setEditCreditPurchase({
      open: true,
      classifyResponse,
      availableCreditsByCode,
      customerType: creditsResponse.customer_type || null,
    });
    return false;
  };

  const closeEditCreditPurchase = () => {
    setEditCreditPurchase(EDIT_CREDIT_PURCHASE_INITIAL_STATE);
  };

  const closeSubmissionConfirmation = () => {
    editConfirmOpenRef.current = false;
    if (editCreditCheckAbortRef.current) {
      editCreditCheckAbortRef.current.abort();
    }
    setShowConfirmationModal(0);
  };

  const handleEditConfirmPrimaryAction = async (selectedScheduleDateKey) => {
    if (submissionEditingSample?.issueFlow) {
      setShowConfirmationModal(4);
      return;
    }
    if (editCreditCheckLoading) {
      return;
    }
    editConfirmOpenRef.current = true;
    const canSubmit = await checkEditedSampleCredits();
    if (!canSubmit || !editConfirmOpenRef.current) {
      return;
    }
    handleConfirmSubmitWithSchedule(selectedScheduleDateKey);
  };

  const handleIssueScheduleConfirm = async (selectedScheduleDateKey) => {
    if (!selectedScheduleDateKey || !submissionEditingSample?.issueFlow) return;

    setSubmitLoadingState(true);
    const selectedDate = moment(selectedScheduleDateKey, "YYYY-M-D", true);
    const scheduleDate = selectedDate.isValid()
      ? selectedDate.format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    const isToday = selectedDate.isValid() && selectedDate.isSame(moment(), "day");

    const { submissionID, submissionName } = submissionDetails;
    const { sample, issueType } = submissionEditingSample;
    const newSample = sampleList[0];
    const samplePayload = buildResolveSampleIssueSamplePayload(
      {
        ...sample,
        issue_type: issueType,
        side: sample.sample_category || sampleCategory,
      },
      { sample_category: sampleCategory, submit_id: submissionID },
      newSample,
    );

    const { success, message, result } = await resolveSampleIssues({
      action: isToday ? "resubmit" : "reschedule",
      submission_id: submissionID,
      sample: samplePayload,
      schedule_date: scheduleDate,
      submission_name: submissionName,
    });
    setSubmitLoadingState(false);

    if (!success) {
      toast.error(message);
      return;
    }

    if (result?.new_submission_id) {
      setSubmissionDetails((prev) => ({ ...prev, submissionID: result.new_submission_id }));
    }

    setShowConfirmationModal(0);
    setShowSuccessAnimation(true);
  };

  const finishAfterReceiptFlow = () => {
    setShowScheduleShipmentModal(false);
    history.push(SAMPLE_SUBMISSION_BASE);
    if (isLoggedOut) resetSubmissionFormState();
  };

  const handleIssueFlowDeleteClick = () => {
    setShowConfirmationModal(5);
  };

  const handleConfirmIssueFlowDelete = async () => {
    if (!submissionEditingSample?.issueFlow) return;

    setLoadSampleDeleting(true);
    const newSample = sampleList[0];
    const { sample, issueType } = submissionEditingSample;
    const samplePayload = buildResolveSampleIssueSamplePayload(
      {
        ...sample,
        issue_type: issueType,
        side: sample.sample_category || sampleCategory,
      },
      { sample_category: sampleCategory, submit_id: submissionDetails.submissionID },
      newSample,
    );

    const { success, message } = await resolveSampleIssues({
      action: "delete",
      submission_id: submissionDetails.submissionID,
      sample: samplePayload,
    });
    setLoadSampleDeleting(false);

    if (!success) {
      toast.error(message);
      return;
    }

    setShowConfirmationModal(0);
    toast.success("Sample successfully deleted");
    if (embeddedIssueModal) {
      if (typeof onIssueFlowSuccess === "function") onIssueFlowSuccess();
      if (typeof onCloseEmbedded === "function") onCloseEmbedded();
      return;
    }
    handleGoBackToMainPage();
  };

  /**
   * Stub payload for issue-flow submit when the sample has no edits.
   */
  const buildNoChangesEditPayload = () => {
    const oldSample = sampleFromSubmission.current ?? {};
    const newSample = sampleList[0] ?? {};
    return {
      noChanges: true,
      sample_id: oldSample.sample_id,
      sample_type: oldSample.sample_type ?? "",
      oldSample,
      newSample: { ...newSample },
    };
  };

  const openScheduleShipmentModal = async () => {
    if (scheduleShipmentLoading) return;
    setScheduleShipmentLoading(true);

    const { success, message, address } = await getCustomerAddress(null, "");
    if (success) {
      setCustomerLogistics(address?.logistics ?? null);
    } else {
      toast.error(message || "Failed to load pickup options");
      // Fall back to FedEx Drop-Off only when customer info cannot be loaded
      setCustomerLogistics(null);
    }

    setScheduleShipmentLoading(false);
    setShowScheduleShipmentModal(true);
  };

  /**
   * Handle when submission is successful and user wants to close the receipt modal
   */
  const handleSubmissionDone = () => {
    setShowReceiptModal(false);
    setSubmissionEditingSample(null);
    if (embeddedIssueModal) {
      if (typeof onIssueFlowSuccess === "function") onIssueFlowSuccess();
      if (typeof onCloseEmbedded === "function") onCloseEmbedded();
      return;
    }
    if (hasPermission(permissions.schedules.pickupRequest)) {
      openScheduleShipmentModal();
      return;
    }
    finishAfterReceiptFlow();
  };

  const handleScheduleShipmentNext = (selection) => {
    if (!selection?.createPickup || !selection?.pickupMethod) {
      finishAfterReceiptFlow();
      return;
    }

    const userInfo = getUserCredentials();
    const submittedBy = (userInfo?.uid === "support" ? "" : (userInfo?.user_name || ""))
      || customerDetails.submittedBy
      || "";
    // Capture before resetSubmissionFormState — it nulls the receipt ref.
    const submitDate = submissionForReceiptModal.current?.submit_date
      || moment().format();

    setShowScheduleShipmentModal(false);
    if (isLoggedOut) resetSubmissionFormState();

    history.push({
      pathname: SUPPLY_PICKUP_PATH,
      state: {
        createPickupWizard: buildPickupScheduleWizardState(
          selection.pickupMethod,
          [{
            submit_id: submissionDetails.submissionID,
            submit_name: submissionDetails.submissionName,
            po: submissionDetails.poNumber,
            num_samples: sampleList.length,
            submit_date: submitDate,
            submitted_by: submittedBy,
          }],
        ),
      },
    });
  };

  /**
   * Check the differences between old and edited sample,
   * if there are differences, return payload else null.
   * @return {Object | null} return payload if there are changes, else null
   */
  const generateSubmissionEditingSamplePayload = () => {
    const {
      status,
      sample,
    } = submissionEditingSample;
    const oldSample = sampleFromSubmission.current;
    const { submissionID } = submissionDetails;
    const newSample = sampleList[0];
    oldSample.uuid = newSample.uuid;
    const newSampleCopy = { ...newSample };
    oldSample.num_composite_samples = sample.num_composite_samples ?? 0;
    oldSample.composite_fieldnames = sample.composite_fieldnames ?? [];
    newSampleCopy.num_composite_samples = newSample.num_composite_samples ?? 0;
    newSampleCopy.composite_fieldnames = newSample.composite_fieldnames ?? [];

    if (sampleCategory === "environment") {
      delete newSampleCopy.image_file; // oldSample does not have this key, remove it for comparison
      newSampleCopy.image_path = oldSample.image_path; // newSample does not have image_path, add for comparison
    }
    if (isEqual(oldSample, newSampleCopy)) {
      return null;
    }

    const payload = {
      submission_id: submissionID,
      submission_status: status,
      sample_id: oldSample.sample_id,
      sample_type: oldSample.sample_type ?? sample.sample_type ?? "", // if sample_type is not part of fields, get the sample_type from the unmodified sample object from backend
      oldSample,
      newSample: newSampleCopy,
      test_list: newSample.test_list,
    };

    /** If Sample ID changed, add new one to payload */
    if (oldSample.sample_id !== newSample.sample_id) {
      payload.new_sample_id = newSample.sample_id;
    }
    /** If Sample Type changed, add new one to payload */
    if ((oldSample.sample_type ?? "") !== (newSample.sample_type ?? "")) {
      payload.new_sample_type = newSample.sample_type ?? "";
    }
    /** Figure out which tests were deleted/added */
    if (!isEqual(oldSample.test_list, newSample.test_list)) {
      const deletedTests = difference(oldSample.test_list, newSample.test_list);
      const addedTests = difference(newSample.test_list, oldSample.test_list);
      if (deletedTests.length > 0) {
        payload.deleted_tests = deletedTests;
      }
      if (addedTests.length > 0) {
        payload.added_tests = addedTests;
      }
    }

    /** If environment, check if image was edited */
    if (sampleCategory === "environment" && (oldSample.image_src ?? "") !== (newSample.image_src ?? "")) {
      payload.image_src = oldSample.image_src;
      payload.new_image_src = newSample.image_src;
    }

    submissionEditingSamplePayload.current = payload;
    return payload;
  };

  /**
   * When user clicks submit button and no samples are added, show toast message.
   * When user clicks submit button and there are unsaved changes, show confirm modal.
   * When user clicks submit button with no unsaved changes, proceed with handleSubmit.
   */
  const handleSubmitButtonClick = () => {
    if (sampleList.length === 0) {
      toast.error("No samples added");
      return;
    }
    const isDraftFlow = !submissionEditingSample && !submissionAddingSamples;
    if (isDraftFlow && sampleList.some((sample) => (sample.test_list?.length ?? 0) === 0)) {
      toast.error("Each sample must have at least one test.");
      return;
    }
    if (submissionEditingSample) {
      if (submissionEditingSample.issueFlow) {
        const payload = generateSubmissionEditingSamplePayload();
        submissionEditingSamplePayload.current = payload || buildNoChangesEditPayload();
        setShowConfirmationModal(2);
        setEditingSubmittedSampleComposite(false);
      } else {
        const payload = generateSubmissionEditingSamplePayload();
        if (payload) {
          setShowConfirmationModal(2);
          setEditingSubmittedSampleComposite(false);
        } else {
          toast.error("No edits made to sample");
        }
      }
    } else {
      setShowConfirmationModal(2);
    }
  };

  // Check pesticides tests in sample list
  const checkPesticidesTests = () => {
    const containsPesticide = Object.values(testsSelected).some((test) => test.test_category === "MRL");
    return containsPesticide && sampleCategory !== "environment" && hasPermission(permissions.global.specialPesticides);
  };

  /**
   * After add/update sample succeeds, reset fields/tests/composite in parent so the expanded grid
   * can unmount immediately without waiting on SampleDetails (avoids a multi-second form flash).
   */
  const resetSampleEntryStateAfterCommit = () => {
    if (!saveTestsForNext) {
      setTestsSelected({});
    }
    sampleFields.forEach((field) => {
      if (!inputValuesSavedForNext[field]) {
        const el = inputValuesRefs.current[field]?.ref;
        if (el != null) {
          el.value = "";
        }
      }
    });
    if (sampleCategory === "environment" && !inputValuesSavedForNext.img) {
      setImageInfoRef({ originalUrl: "", editedUrl: "", file: null });
    }
    setCompositeSample({ unique: null, identifier: [], sample_count: null });
    if (backRef?.current?.clearCompositeData) {
      backRef.current.clearCompositeData();
    }
    setClearSampleDetailsForm(false);
  };

  /**
   * Add sample. Loop through sampleFields, grab the ref.
   * If ref exists and has a non-empty input, add field info and value to sample obj.
   * Set the updated list, clear form (keeping the values that are saved for next).
   * Make the api call to add sample.
   */
  const handleAddSample = async () => {
    setWaitingForAddEditAPI(true);
    let atLeastOneSampleIdField = false;
    /** Always add the po in the sample's level */
    const newSample = { po: submissionDetails.poNumber };
    const savedFields = {};
    /** Get field values and composite values from refs */
    const compositeInputValues = backRef?.current?.getInputValues();
    const compositeValues = backRef?.current?.getCompositeData();
    const isMrl = checkPesticidesTests();
    for (let i = 0; i < sampleFields.length; i++) {
      /** InputValues and compositeData in case of composite samples */
      const json_field = sampleFields[i];
      const ref = inputValuesRefs.current[json_field]?.ref?.value;
      const compositeValueRef = compositeInputValues[json_field] ?? "";
      let refValue;

      // Determine refValue based on conditions
      if (isMrl && json_field === "sample_type") {
        refValue = ref; // Use ref if isMrl is true and json_field is "sample_type"
      } else if (compositeValues?.unique) {
        refValue = compositeValueRef; // Use compositeValueRef if compositeValues is unique
      } else {
        refValue = ref; // Default to ref
      } if (refValue !== undefined && refValue !== null) {
        const val = refValue.trim();
        if (val) {
          if (sampleIdFields.has(json_field)) {
            atLeastOneSampleIdField = true;
          }
          if (inputValuesSavedForNext[json_field]) {
            savedFields[json_field] = val;
          }
        }
        newSample[json_field] = val;
      } else {
        newSample[json_field] = "";
      }
    }

    /** Check if at least one sample id field is filled out */
    if (!atLeastOneSampleIdField) {
      toast.error((isLoggedOut && !thirdParty) ? "Sample ID is required" : "At least one Sample ID field is required");
      setWaitingForAddEditAPI(false);
      return;
    }

    /** Because submission editing apis don't regenerate sample id from fields, call generateSampleID to get the most updated sample id before proceeding */
    if (submissionAddingSamples) {
      const { success, sample_id } = await generateSampleID(newSample);
      if (success) {
        if (sample_id.length > CHAR_LIMITS.sample_id) {
          toast.error("Sample ID is too long");
          setWaitingForAddEditAPI(false);
          return;
        }
        newSample.sample_id = sample_id;
      } else {
        toast.error("Unable to generate Sample ID");
        setWaitingForAddEditAPI(false);
        return;
      }
    } else if (!isLoggedOut || thirdParty) {
      newSample.sample_id = generatedSampleID;
    }

    /** Check if at least one test selected */
    if (!isEmpty(testsSelected)) {
      newSample.test_list = Array.from(Object.keys(testsSelected));
    } else {
      toast.error("No tests selected for this sample");
      setWaitingForAddEditAPI(false);
      return;
    }

    /** If this is logged in env sample submission, handle image upload */
    if (sampleCategory === "environment" && (!isLoggedOut || thirdParty)) {
      const { file, editedUrl } = imageInfoRef.current;
      if (file && editedUrl) { // a new image or crop was created
        const { success, path } = await addImageToAWS(file);
        if (!success) {
          toast.error("Image failed to upload");
          setWaitingForAddEditAPI(false);
          return;
        }
        newSample.image_path = path ?? "";
        newSample.image_file = file ?? null;
      } else if (!editedUrl) { // the image was removed from the sample
        newSample.image_path = "";
      }
      if (inputValuesSavedForNext.img) {
        savedFields.image_path = newSample.image_path ?? "";
      }
    }
    /** If sample is composite sample */
    newSample.num_composite_samples = compositeValues?.sample_count ?? 0;
    newSample.composite_fieldnames = compositeValues?.identifier ?? [];
    /** If this is a draft, get the draft api response otherwise use default */
    let response = { success: true, sampleID: newSample.sample_id };
    if ((!isLoggedOut || thirdParty) && !submissionAddingSamples && !isLoadingSampleId) {
      response = await apiAddSampleDraft(newSample, savedFields);
    }

    /** Update the sample list with the new sample, clear relevant state */
    const { success, sampleID } = response;
    if (success) {
      newSample.sample_id = sampleID;
      if (sampleCategory === "environment" && (!isLoggedOut || thirdParty)) {
        newSample.image_path = newSample.image_path ?? "";
        newSample.image_file = newSample.image_file ?? "";
        newSample.image_src = imageInfoRef.current.editedUrl ?? "";
      }
      newSample.uuid = uuid();
      sampleList.push(newSample);
      setSampleList([...sampleList]);
      setSavedState(null);
      setLoadSavedState(false);
      resetSampleEntryStateAfterCommit();
      setPesticideSample("");
      /* scroll sample list to bottom */
      if (sampleListScrollbar.current) {
        sampleListScrollbar.current.scrollerElement.scrollTo({
          top: sampleListScrollbar.current.scrollerElement.scrollHeight,
          behavior: "smooth",
        });
      }
      if ((!isLoggedOut || thirdParty) && !submissionAddingSamples) {
        setDraftLastSavedTime(moment().format());
      }
      setClearTestSearch(true);
    }
    setWaitingForAddEditAPI(false);
  };

  /**
   * Edit sample. Same flow as add sample, except
   * sample at that index is updated instead of pushing
   * new sample to sample list.
   */
  const handleSaveEditedSample = async (submitEdit = false) => {
    setWaitingForAddEditAPI(true);
    let atLeastOneSampleIdField = false;
    const newSample = { po: submissionDetails.poNumber };
    const savedFields = {};

    /** Get field values and composite values from refs */
    const compositeInputValues = backRef?.current?.getInputValues();
    const compositeValues = backRef?.current?.getCompositeData();
    const isMrl = checkPesticidesTests();

    /** Get field values from refs */
    for (let i = 0; i < sampleFields.length; i++) {
      const json_field = sampleFields[i];
      const ref = inputValuesRefs.current[json_field]?.ref?.value;
      const compositeValueRef = compositeInputValues[json_field] ?? "";
      let refValue;

      // Determine refValue based on conditions
      if (isMrl && json_field === "sample_type") {
        refValue = ref; // Use ref if isMrl is true and json_field is "sample_type"
      } else if (compositeValues?.unique) {
        refValue = compositeValueRef; // Use compositeValueRef if compositeValues is unique
      } else {
        refValue = ref; // Default to ref
      } if (refValue !== undefined && refValue !== null) {
        const val = refValue.trim();
        if (val) {
          if (sampleIdFields.has(json_field)) {
            atLeastOneSampleIdField = true;
          }
          if (inputValuesSavedForNext[json_field]) {
            savedFields[json_field] = val;
          }
        }
        newSample[json_field] = val;
      } else {
        newSample[json_field] = "";
      }
    }
    /** If sample is composite sample */
    newSample.num_composite_samples = compositeValues?.sample_count ?? 0;
    newSample.composite_fieldnames = compositeValues?.identifier ?? [];

    /** Check if at least one sample id field is filled out */
    if (!atLeastOneSampleIdField) {
      toast.error((isLoggedOut && !thirdParty) ? "Sample ID is required" : "At least one Sample ID field is required");
      setWaitingForAddEditAPI(false);
      return;
    }

    /** Because submission editing apis don't regenerate sample id from fields, call generateSampleID to get the most updated sample id before proceeding */
    if (submissionEditingSample || submissionAddingSamples) {
      const { success, sample_id } = await generateSampleID(newSample, submissionEditingSample ? submissionEditingSample.sample.sample_id : sampleEditing.sample_id);
      if (success) {
        if (sample_id.length > CHAR_LIMITS.sample_id) {
          toast.error("Sample ID is too long");
          setWaitingForAddEditAPI(false);
          return;
        }
        newSample.sample_id = sample_id;
      } else {
        toast.error("Unable to generate Sample ID");
        setWaitingForAddEditAPI(false);
        return;
      }
      newSample.sample_id = sample_id;
    } else if (!isLoggedOut || thirdParty) {
      newSample.sample_id = generatedSampleID;
    }

    /** Check if at least one test selected */
    if (!isEmpty(testsSelected)) {
      newSample.test_list = Array.from(Object.keys(testsSelected));
    } else {
      toast.error("No tests selected for this sample");
      setWaitingForAddEditAPI(false);
      return;
    }

    /** If this is logged in env sample submission, handle image upload */
    const oldSample = sampleList[sampleEditingIdx];
    if (submissionEditingSample?.issueFlow && !String(newSample.sample_type ?? "").trim()) {
      newSample.sample_type = oldSample.sample_type
        ?? submissionEditingSample.sample?.sample_type
        ?? "";
    }
    let deleteImagePath = null;
    if (sampleCategory === "environment" && (!isLoggedOut || thirdParty) && !submissionEditingSample) {
      const { file, editedUrl, imageWasEdited } = imageInfoRef.current;
      if (imageWasEdited) {
        if (file && editedUrl) { // a new image or crop was created
          if (oldSample.image_path) {
            deleteImagePath = oldSample.image_path;
          }
          const { success, path } = await addImageToAWS(file);
          if (!success) {
            toast.error("Image failed to upload");
            setWaitingForAddEditAPI(false);
            return;
          }
          newSample.image_path = path ?? "";
          newSample.image_file = file ?? null;
        } else if (!editedUrl) { // the image was removed from the sample
          if (oldSample.image_path) {
            deleteImagePath = oldSample.image_path;
          }
          newSample.image_path = "";
        }
      } else {
        newSample.image_path = oldSample.image_path ?? "";
        newSample.image_file = oldSample.image_file ?? null;
      }

      if (inputValuesSavedForNext.img) {
        savedFields.image_path = newSample.image_path ?? "";
      }
    }

    /** If this is a draft, get the draft api response otherwise use default */
    let response = { success: true, sampleID: newSample.sample_id };
    if ((!isLoggedOut || thirdParty) && !submissionEditingSample && !submissionAddingSamples) {
      response = await apiEditSampleDraft(oldSample.sample_id, newSample, savedFields);
    }

    /** Update the sample list with the edited sample, clear relevant state */
    const { success, sampleID } = response;
    if (success) {
      newSample.sample_id = sampleID;
      if (sampleCategory === "environment" && (!isLoggedOut || thirdParty)) {
        if (!submissionEditingSample) { // for editing a submitted sample, at this point we don't upload the image so the new path is not known, don't add the image_path key
          newSample.image_path = newSample.image_path ?? "";
        }
        newSample.image_file = !submissionEditingSample ? newSample.image_file ?? null : imageInfoRef.current.file;
        newSample.image_src = imageInfoRef.current.editedUrl ?? "";
        if (deleteImagePath) {
          deleteFileFromS3WithPresigned([deleteImagePath], "private");
        }
      }
      newSample.uuid = oldSample.uuid;
      sampleList[sampleEditingIdx] = newSample;
      setSampleList([...sampleList]);
      if (!submitEdit) {
        resetSampleEntryStateAfterCommit();
      }
      setLoadSampleEditing(false);
      setSampleEditing({});
      setSampleEditingIdx(-1);
      setSavedState(null);
      setLoadSavedState(false);
      imageInfoRef.current.imageWasEdited = false;
      if ((!isLoggedOut || thirdParty) && !submissionEditingSample && !submissionAddingSamples) {
        setDraftLastSavedTime(moment().format());
      }
      if (!submitEdit) {
        setClearTestSearch(true);
      }
    }
    setWaitingForAddEditAPI(false);
    if (submitEdit) handleSubmitButtonClick();
  };

  /**
   * Set sampleEditing and sampleEditingIdx states,
   * select tests from sample's test_list
   */
  const handleEditSample = async (idx) => {
    if (sampleEditingIdx === -1) {
      saveCurrentState(inputValuesSavedForNext, testsSelected, saveTestsForNext);
    }
    setLoadSampleEditing(true);
    setSampleEditing({ ...sampleList[idx] });
    setSampleEditingIdx(idx);
    setSaveTestsForNext(false);
  };

  /** Clear sampleEditing and sampleEditingIdx states */
  const handleCancelEditSample = () => {
    setLoadSampleEditing(false);
    setSampleEditing({});
    setSampleEditingIdx(-1);
    // Issue overview does not use the expanded saved-state form; avoid flash/broken layout.
    if (submissionEditingSample?.issueFlow) {
      setLoadSavedState(false);
    } else {
      setLoadSavedState(true);
    }
    setClearTestSearch(true);
    setPesticideSample("");
    setCompositeSample({ unique: null, identifier: [], sample_count: null });
    setEditingSubmittedSampleComposite(true);
  };

  /**
   * Delete sample at sampleToDeleteIdx in the sampleList.
   */
  const handleConfirmDeleteSample = async () => {
    setLoadSampleDeleting(true);
    const sample = sampleList[sampleToDeleteIdx];
    // console.log("delete", sample);
    const success = (!isLoggedOut || thirdParty) && !submissionAddingSamples ? await apiDeleteSampleDraft(sample.sample_id, sample.sample_type ?? "") : true;
    if (success) {
      if (sampleEditingIdx === sampleToDeleteIdx) {
        handleCancelEditSample();
      } else if (sampleEditingIdx > sampleToDeleteIdx) {
        setSampleEditingIdx(sampleEditingIdx - 1); // update the sample editing idx if it will change after the delete
      }
      if (sample.image_path) {
        deleteFileFromS3WithPresigned([sample.image_path], "private");
      }
      sampleList.splice(sampleToDeleteIdx, 1); // remove item at that index
      generateSampleID(undefined, sampleEditing?.sample_id, [...sampleList]); // generate sample id, when in normal or editing state
      setSampleList([...sampleList]);
      setSampleToDeleteIdx(-1);
      setShowConfirmationModal(0);
      if (!submissionAddingSamples) {
        setDraftLastSavedTime(moment().format());
      }
    }
    setLoadSampleDeleting(false);
  };

  /**
   * Show delete confirmation modal when user wants to delete sample.
   * @param  {Number} idx index of sample in sampleList array
   */
  const handleDeleteClick = async (idx) => {
    setSampleToDeleteIdx(idx);
    setShowConfirmationModal(3);
  };

  let confirmSubmitText = `Added Samples (${sampleList.length}) will be submitted for testing.`;
  if (submissionEditingSample) {
    confirmSubmitText = "Are you sure you want to submit these edits?";
  } else if (submissionAddingSamples) {
    confirmSubmitText = `${sampleList.length} sample(s) will be added to the submission.`;
  }

  const showLoadingDiv = !showAddressPage && (loadDraftState || loadSampleEditing || loadSavedState || clearSampleDetailsForm || waitingForAddEditAPI || loadingImage);
  const showIssueOverviewLayout = submissionEditingSample?.issueFlow
    && sampleEditingIdx === -1
    && !showAddressPage;

  return (
    <>
      {showSuccessAnimation && <SuccessAnimation message="Successfully submitted!" />}
      {showReceiptModal && (
        <SubmissionReceiptModal
          maskClosable={false}
          customerId={customerDetails.customerID}
          po={submissionDetails.poNumber}
          comment={submissionDetails.comment}
          submissionId={submissionDetails.submissionID}
          submissionFromParent={(isLoggedOut && !thirdParty) ? submissionForReceiptModal.current : undefined}
          showReceipt={showReceiptModal}
          handleReceipt={handleSubmissionDone}
          headerTitleText=""
        // confirmButtonText={isLoggedOut ? "Submit Another Submission" : "Go To Submissions Page"}
        />
      )}
      {showScheduleShipmentModal && (
        <ScheduleShipmentModal
          open={showScheduleShipmentModal}
          submissionName={submissionDetails.submissionName}
          logistics={customerLogistics}
          onLater={finishAfterReceiptFlow}
          onCancel={finishAfterReceiptFlow}
          onNext={handleScheduleShipmentNext}
        />
      )}
      {(showConfirmationModal && showConfirmationModal <= 2) // submission confirmation modal
        ? (
          <SampleSubmissionConfirmModal
            headerText="Submission Confirmation"
            bodyText={showConfirmationModal === 1
              ? "You have unsaved changes. Only the added samples will be submitted for testing."
              : confirmSubmitText}
            buttonText={["Cancel", "Submit", "Submitting"]}
            buttonFunctions={[closeSubmissionConfirmation, handleConfirmSubmit]}
            loading={submitLoadingState || editCreditCheckLoading}
            editedSamplePayload={submissionEditingSamplePayload.current}
            sampleFields={sampleFields}
            sampleFieldsInfo={sampleFieldsInfo}
            sampleIdFields={sampleIdFields}
            submissionComment={!submissionAddingSamples && !submissionEditingSample}
            commentRef={commentRef}
            handleEditSample={handleEditSample}
            handleCancelEditSample={handleCancelEditSample}
            submissionEditingSample={submissionEditingSample}
            onPrimaryAction={handleEditConfirmPrimaryAction}
          />
        ) : null}
      {showConfirmationModal === 4 && (
        <SampleSubmissionConfirmModal
          variant="issueSchedule"
          headerText="Submission Confirmation"
          bodyText="Schedule a replacement sample to continue testing."
          buttonText={["Cancel", "Submit", "Scheduling"]}
          buttonFunctions={[() => setShowConfirmationModal(0)]}
          loading={submitLoadingState}
          commentRef={commentRef}
          handleEditSample={handleEditSample}
          submissionEditingSample={submissionEditingSample}
          onPrimaryAction={handleIssueScheduleConfirm}
        />
      )}
      {submissionEditingSample && (
        <CreditPurchaseModal
          open={editCreditPurchase.open}
          onClose={closeEditCreditPurchase}
          classifyResponse={editCreditPurchase.classifyResponse}
          availableCreditsByCode={editCreditPurchase.availableCreditsByCode}
          variant={editCreditPurchase.customerType}
          onPayNow={handleConfirmSubmit}
          saveDraftOnSelectQuantity={false}
          selectQuantityDescription="Your sample changes won't be saved, and you'll be redirected to Billing to purchase test credits."
        />
      )}
      {(showConfirmationModal === 3) // delete confirmation modal
        ? (
          <SampleSubmissionConfirmModal
            headerText="Delete Sample Confirmation"
            bodyText="Are you sure you want to delete this sample? This cannot be undone."
            buttonText={["Cancel", "Delete", "Deleting"]}
            buttonFunctions={[() => { setShowConfirmationModal(0); setSampleToDeleteIdx(-1); }, () => handleConfirmDeleteSample(sampleToDeleteIdx)]}
            loading={loadSampleDeleting}
            compositeRef={backRef}
          />
        ) : null}
      {showConfirmationModal === 5 && (
        <SampleSubmissionConfirmModal
          headerText="Delete Sample"
          bodyText="Are you sure you want to permanently delete this sample? This action is irreversible."
          buttonText={["Cancel", "Delete", "Deleting"]}
          buttonFunctions={[() => setShowConfirmationModal(0), handleConfirmIssueFlowDelete]}
          loading={loadSampleDeleting}
          handleCancelEditSample={handleCancelEditSample}
          submissionEditingSample={submissionEditingSample}
        />
      )}
      <div className={`sample-submission-background sample-submission-background__Form ${isLoggedOut ? "logged-out" : ""} ${showAddressPage ? "sample-submission-background-address" : ""} ${showIssueOverviewLayout ? "sample-submission-background__Form--issueOverview" : ""}`}>
        {showLoadingDiv && (<div className="SampleSubmissionForm__Loading" />)}
        <div className={`new-submission-pages-container${showAddressPage ? " address-page-container" : ""}${submissionEditingSample && !showAddressPage && !showIssueOverviewLayout ? " sample-details-two-col" : ""}${showIssueOverviewLayout ? " sample-details-issue-overview" : ""}`}>
          {showAddressPage
            ? (
              <SubmissionDetailsAddressPage
                handleGoBackToMainPage={handleGoBackToMainPage}
                submissionDetails={submissionDetails}
                setSubmissionDetails={setSubmissionDetails}
                setShowAddressPage={setShowAddressPage}
                customerDetails={customerDetails}
                setCustomerDetails={setCustomerDetails}
                sampleCategory={sampleCategory}
                setSubmissionNameNav={setSubmissionNameNav}
                addressPageBreadcrumbBackRef={addressPageBreadcrumbBackRef}
                sampleFieldsInfo={sampleFieldsInfo}
              />
            ) : (
              <>
                {/* {(submissionAddingSamples || submissionEditingSample) && (
                <SubmissionInfoBanner submissionName={submissionDetails.submissionName} poNumber={submissionDetails.poNumber} />
                )} */}
                <SampleDetailsPage
                  inputValuesRefs={inputValuesRefs}
                  setInputValuesRefs={setInputValuesRefs}
                  inputValuesSavedForNext={inputValuesSavedForNext}
                  toggleSaveForNext={toggleSaveForNext}
                  clearSampleDetailsForm={clearSampleDetailsForm}
                  setClearSampleDetailsForm={setClearSampleDetailsForm}
                  loadDraftState={loadDraftState}
                  setLoadDraftState={setLoadDraftState}
                  loadSampleEditing={loadSampleEditing}
                  setLoadSampleEditing={setLoadSampleEditing}
                  sampleEditing={sampleEditing}
                  handleGoBackToAddressPage={handleGoBackToAddressPage}
                  setInvalidInputFound={setInvalidInputFound}
                  savedState={savedState}
                  loadSavedState={loadSavedState}
                  setLoadSavedState={setLoadSavedState}
                  setSavedState={setSavedState}
                  setTestsSelected={setTestsSelected}
                  saveTestsForNext={saveTestsForNext}
                  testsSelected={testsSelected}
                  generateSampleID={debouncedGenerateSampleID}
                  setInputValueAutofilled={setInputValueAutofilled}
                  handleGoBackToMainPage={handleGoBackToMainPage}
                  generatedSampleID={generatedSampleID}
                  clearTestSearch={clearTestSearch}
                  setClearTestSearch={setClearTestSearch}
                  compositeSample={compositeSample}
                  customerDetails={customerDetails}
                  waitingForAddEditAPI={waitingForAddEditAPI}
                  sampleEditingIdx={sampleEditingIdx}
                  handleSaveEditedSample={handleSaveEditedSample}
                  handleAddSample={handleAddSample}
                  handleCancelEditSample={handleCancelEditSample}
                  invalidInputFound={invalidInputFound}
                  invalidMandatoryFound={invalidMandatoryFound}
                  setInvalidMandatoryFound={setInvalidMandatoryFound}
                  sampleList={sampleList}
                  handleEditSample={handleEditSample}
                  handleDeleteClick={handleDeleteClick}
                  handleSubmitButtonClick={handleSubmitButtonClick}
                  handleIssueFlowDeleteClick={handleIssueFlowDeleteClick}
                  draftEditing={draftEditing}
                  sampleFields={sampleFields}
                  sampleFieldsInfo={sampleFieldsInfo}
                  delimiterRegex={delimiterRegex}
                  imageInfoRef={imageInfoRef}
                  setImageInfoRef={setImageInfoRef}
                  setLoadingImage={setLoadingImage}
                  submissionEditingSample={submissionEditingSample}
                  submissionAddingSamples={submissionAddingSamples}
                  sampleIdFields={sampleIdFields}
                  invalidTest={invalidTest}
                  setInvalidTest={setInvalidTest}
                  testInfoMap={testInfoMap}
                  sampleFromSubmission={sampleFromSubmission}
                  sampleIDGenerationError={sampleIDGenerationError}
                  submissionDetails={submissionDetails}
                  pesticideSample={pesticideSample}
                  setPesticideSample={setPesticideSample}
                  sampleCategory={sampleCategory}
                  ref={closeRef}
                  setShowExitModal={setShowExitModal}
                  isLoadingSampleId={isLoadingSampleId}
                  editingSubmittedSampleComposite={editingSubmittedSampleComposite}
                  setEditingSubmittedSampleComposite={setEditingSubmittedSampleComposite}
                  clearCompositeSaveForNext={clearCompositeSaveForNext}
                  onSaveDraftForRequestNew={handleSaveDraftForRequestNew}
                />
              </>

            )}
        </div>
      </div>
    </>
  );
}
